import * as React from "react";
import { Alert, Button } from "react-bootstrap";
import { ActionHandlerFunction } from "@preveil-api";
import { AdminUIActionTypes } from "src/common";
import { Icon } from "src/components";

type AllProps = {
    enable_retry: boolean;
    handleAction: ActionHandlerFunction;
}

function ErrorPanelComponent(props: AllProps) {
    const { enable_retry, handleAction } = props;

    return <Alert variant="warning" className="max-400">
        <h4><Icon className="ficon-alert-triangle me-2 fs-1 text-primary" />There was a problem getting the security settings, Please try again</h4>
        {
            enable_retry &&
            <Button variant="no-outline-primary" onClick={() => handleAction({ actionType: AdminUIActionTypes.Refresh })}>Reload</Button>
        }

    </Alert>;
}
export default React.memo(ErrorPanelComponent);
